'use client';

import { useTranslations } from 'next-intl';

import { Typography } from '@/components/atoms';
import { LinkButton } from '@/components/molecules';

const NotFoundPage = ({}) => {
  const t = useTranslations();

  return (
    <main className="min-h-screen flex flex-col items-center justify-center px-4 py-8 sm:py-12 md:py-16">
      <div className="w-full max-w-md">
        <Typography.Heading
          variant="h1"
          className="text-(--color-text-tertiary) not-italic! font-(family-name:--font-headings) text-(length:--text-h1) font-(--font-weight-h1) mb-0"
        >
          404
        </Typography.Heading>
        <Typography.Heading
          variant="h4"
          className=" font-(--font-weight-h4) not-italic! text-(length:--text-h4)"
        >
          {t('WE_CANT_FIND_CONTENT')}
        </Typography.Heading>
        <Typography.Text
          variant="paragraph"
          className="font-(--font-weight-body-2xl) not-italic! text-(length:--text-body-2xl) -mt-4"
        >
          {t('CONTENT_NO_LONGER_ACCESSIBLE')}
        </Typography.Text>
        <div className="flex items-center">
          <LinkButton
            href="/"
            variant="primary"
            className="w-full mt-10 border border-(--button-secondary-border-color-active) rounded-(--button-secondary-radius-default) text-(length:--text-button-lg) font-(--font-weight-button-md)"
          >
            {t('GO_BACK_HOME_PAGE')}
          </LinkButton>
        </div>
      </div>
    </main>
  );
};

export default NotFoundPage;
